import { render, staticRenderFns } from "./reportUpload.vue?vue&type=template&id=1b5ff8c8&scoped=true"
import script from "./reportUpload.vue?vue&type=script&lang=js"
export * from "./reportUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5ff8c8",
  null
  
)

export default component.exports